import 'rxjs/add/observable/from';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import { getPushPayload } from '../../services/push-payload/index.tsx';
import { setAllFilters } from '../../state/actions/filters/index.tsx';
import type { ConfigState } from '../../state/reducers/config/types.tsx';
import type { EntitiesState } from '../../state/reducers/entities/types.tsx';
import type { UiState } from '../../state/reducers/ui/types.tsx';
import { getIsCompanyManaged } from '../../state/selectors/app/index.tsx';
import {
	hasInvalidFilterValuesSelector,
	validFilterValuesSelector,
} from '../../state/selectors/cards/index.tsx';
import { isConfigLoaded, isCriticalDataLoaded } from '../../state/selectors/config/index.tsx';
import { isCurrentUserLoaded } from '../../state/selectors/user/index.tsx';
import type { ActionsObservable, MiddlewareAPI, State } from '../../state/types.tsx';

const makeFilter = (
	state:
		| State
		| {
				readonly config: ConfigState;
				readonly entities: EntitiesState;
				readonly ui: UiState;
		  },
) =>
	isCriticalDataLoaded(state) &&
	isCurrentUserLoaded(state) &&
	isConfigLoaded(state) &&
	hasInvalidFilterValuesSelector(state);

export const filterValidValuesEpic =
	(getLocation: () => Location, push: RouterActionPush) =>
	(action$: ActionsObservable, store: MiddlewareAPI) =>
		action$
			.filter(() => makeFilter(store.getState()))
			.mergeMap(() => {
				const state = store.getState();
				const filters = validFilterValuesSelector(state);
				const actions = [setAllFilters(filters)];
				const isCompanyManaged = getIsCompanyManaged(state);
				push(getPushPayload(filters, getLocation(), isCompanyManaged));

				return Observable.from(actions);
			});
